<!-- 缺陷reopen -->
<template>
  <div>
    <a-card title="缺陷状态分布" size="small">
      <div id="test-rate" :style="{ height: height, width: width }" />
    </a-card>
    <a-modal :visible="modalVisible" :title="title" :closable="false" :width="800" @cancel="closeModal">
      <a-table :columns="columns" :data-source="tableData" :width="700">
        <span slot="name" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.name">
            <a class="custom-link" :href="link(record)" target="_blank">{{ record.name }}</a>
          </a-tooltip>
        </span>
        <span slot="serious" slot-scope="text, record">
          <a-tooltip placement="top" :title="record.serious">
            {{ 'p' + record.serious }}
          </a-tooltip>
        </span>
      </a-table>
      <div slot="footer" />
    </a-modal>
  </div>
</template>
<script>
import { getVersionBugStatus } from '@/api/data/quality';
export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '250px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    taskMap: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      myChart: null,
      modalVisible: false,
      title: '',
      tableData: [],
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          key: 'id',
          scopedSlots: { customRender: 'id' }
        },
        {
          title: '缺陷名',
          dataIndex: 'name',
          key: 'name',
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '优先级',
          dataIndex: 'serious',
          key: 'serious',
          width: 120,
          scopedSlots: { customRender: 'serious' }
        }
      ],
      option: {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {},
        series: [
          {
            name: null,
            type: 'pie',
            radius: '60%',
            center: ['50%', '58%'],
            data: [],
            label: {
              formatter: '{b}: {@2012} ({d}%)'
            },
            itemStyle: {
              borderRadius: 6,
              borderColor: '#fff',
              borderWidth: 2
            },
            emphasis: {
              label: {
                show: true,
                fontWeight: 'bold'
              }
            }
          }
        ]
      }
    };
  },
  computed: {
    link() {
      return record => {
        return this.$router.resolve({
          name: 'page:project:quality:issue:detail',
          params: { project_id: record.project_id },
          query: { issueId: record.id }
        }).href;
      };
    }
  },
  watch: {
    filterForm() {
      this.getDiagramData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/pie'); // 饼图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    this.myChart = echarts.init(document.getElementById('test-rate'));
    this.myChart.on('click', params => {
      this.tableData = params.data.detail;
      this.modalVisible = true;
      this.title = params.data.name;
    });
    setTimeout(() => {
      this.getDiagramData();
    }, 100); // 添加延迟
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    closeModal() {
      this.modalVisible = false;
    },
    getDiagramData() {
      getVersionBugStatus(this.filterForm).then(res => {
        this.option.series[0].data = [
          {
            value: res.data.result[0].length,
            name: '待处理',
            detail: res.data.result[0]
          },
          {
            value: res.data.result[1].length,
            name: '处理中',
            detail: res.data.result[1]
          },
          {
            value: res.data.result[2].length,
            name: '测试中',
            detail: res.data.result[2]
          },
          {
            value: res.data.result[3].length,
            name: '已解决',
            detail: res.data.result[3]
          },
          {
            value: res.data.result[4].length,
            name: '已拒绝',
            detail: res.data.result[4]
          },
          {
            value: res.data.result[5].length,
            name: '重复',
            detail: res.data.result[5]
          },
          {
            value: res.data.result[6].length,
            name: '重新打开',
            detail: res.data.result[6]
          },
          {
            value: res.data.result[7].length,
            name: '挂起',
            detail: res.data.result[7]
          }
        ];
        this.drawChart();
      });
    }
  }
};
</script>
